import { render, staticRenderFns } from "./ButtonOptional.vue?vue&type=template&id=67a2324e&scoped=true&lang=pug&"
import script from "./ButtonOptional.vue?vue&type=script&lang=ts&"
export * from "./ButtonOptional.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonOptional.vue?vue&type=style&index=0&id=67a2324e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a2324e",
  null
  
)

export default component.exports